// Labels, colours and formatters shared by the per-payout popup (PayoutLedgerDialog) and the
// full owner ledger page (pages/admin/AdminOwnerLedger.jsx), so the two always read alike.

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

// A net can be negative; toFixed alone would print "$-5.00".
export const signedMoney = (n) => (Number(n) < 0 ? `−${money(-n)}` : money(n));

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }) : "—";

export const ENTRY_LABEL = {
  reseller_income: "Reseller income",
  distributor_commission: "Distributor commission",
  reseller_payout: "Payout",
  distributor_payout: "Payout",
};

// Credit and debit rows use the same status field with different meanings.
export const statusLabel = (e) =>
  e.direction === "debit"
    ? { pending: "Pending", paid_out: "Paid", reversed: "Reversed" }[e.status] || e.status
    : { paid_out: "Settled", available: "Available", pending: "Pending" }[e.status] || e.status;

export const STATUS_STYLE = {
  pending: "bg-yellow-100 text-yellow-700",
  paid_out: "bg-green-100 text-green-700",
  available: "bg-slate-100 text-slate-700",
  reversed: "bg-red-100 text-red-700",
};

export const PAYOUT_STATUS_STYLE = {
  pending: "bg-yellow-100 text-yellow-700",
  processing: "bg-blue-100 text-blue-700",
  completed: "bg-green-100 text-green-700",
  failed: "bg-red-100 text-red-700",
  cancelled: "bg-slate-100 text-slate-600",
};

// A credit row remembers which storefront the sale came from; a payout's own debit row
// has no channel — it isn't for one sale.
export const CHANNEL_LABEL = { edisplay: "Edisplay", infinity: "Infinity", funeral: "Funeral" };
export const CHANNEL_STYLE = {
  edisplay: "bg-indigo-100 text-indigo-700",
  infinity: "bg-sky-100 text-sky-700",
  funeral: "bg-slate-200 text-slate-700",
};
